<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <el-radio-group v-model="requestData.timeType" style="margin-right:5px">
        <el-radio-button label="DAY">按日</el-radio-button>
        <el-radio-button label="MONTH">按月</el-radio-button>
        </el-radio-group>
        <el-date-picker v-model="timevalue" v-if="requestData.timeType==='DAY'" size="small" type="daterange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-date-picker
        style="width:380px"
        v-model="timevalue2"
        v-else
        type="monthrange"
        value-format="yyyy-MM"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份">
        </el-date-picker>
      </div>
    <div style="display: flex;justify-content: space-between">
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        style="margin: 0 0 0 8px"
        download="download.xls"
        v-if="permissionCodes.indexOf('040003001') !== -1"
        value="导出"/>
    </div>
    </div>
    <el-table
    :data="tableData"
    :header-cell-style="{'text-align':'center'}"
    :cell-style="{'text-align':'center'}"
    style="width: 100%">
    <el-table-column
      label="序号"
      type="index">
    </el-table-column>
    <el-table-column
      width="150"
      prop="time"
      label="收费时间">
    </el-table-column>
    <el-table-column label="合计">
      <el-table-column
        prop="totalCount"
        label="车辆数">
      </el-table-column>
      <el-table-column
        prop="totalMoney"
        label="费用">
      </el-table-column>
    </el-table-column>
    <el-table-column label="优惠券">
        <el-table-column label="固定金额优惠券">
        <el-table-column
          prop="couponMoneyCount"
          label="数量">
        </el-table-column>
        <el-table-column
          prop="couponMoneyMoney"
          label="停车券费用">
        </el-table-column>
        <el-table-column
          prop="couponMoneyCarCount"
          label="车辆数">
        </el-table-column>
        </el-table-column>
        <el-table-column label="时长优惠券">
        <el-table-column
          prop="couponTimeCount"
          label="数量">
        </el-table-column>
        <el-table-column
          prop="couponTimeMoney"
          label="停车券费用">
        </el-table-column>
        <el-table-column
          prop="couponTimeCarCount"
          label="车辆数">
        </el-table-column>
        </el-table-column>
    </el-table-column>
        <el-table-column
          prop="freeMoney"
          label="审批免费费用">
        </el-table-column>
        <el-table-column
          prop="freeCount"
          label="车辆数">
        </el-table-column>
        <el-table-column
          prop="chargeMoney"
          label="临时停车结算费用(元)">
        </el-table-column>
        <el-table-column
          prop="chargeCount"
          label="收费车辆数">
        </el-table-column>
        <el-table-column
          prop="memo"
          label="备注">
        </el-table-column>
    </el-table-column>
  </el-table>

  <el-pagination
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    style="margin-top:15px"
    :page-sizes="[10, 20, 50, 100]"
    :current-page="requestData.pageNum"
    :page-size="requestData.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/PropertyFee";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nError, nSuccess, nAlert } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "temporary-parking-fee",
  data() {
    return {
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "临时停车费用"
        }
      ],
      tableData: [],
      requestData: {
        pageSize: 10,
        pageNum: 1,
        timeType: "DAY"
      },
      exportUrl: "",
      total: 0,
      dateChange: "",
      timevalue: [],
      timevalue2: [],
      permissionCodes: ""
    };
  },
  created() {
    this.getCreateTime();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-01" + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    beforeDownload() {
      this.exportUrl = `${api.exportBillStatistic}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&startTime=${
        this.requestData.startTime
      }&endTime=${this.requestData.endTime}&timeType=${
        this.requestData.timeType
      }`;
    },
    getPage() {
      if (this.requestData.timeType === "DAY") {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || "";
          this.requestData.endTime = this.timevalue[1] || "";
        } else {
          this.requestData.startTime = "";
          this.requestData.endTime = "";
        }
      }
      if (this.requestData.timeType === "MONTH") {
        if (this.timevalue2) {
          console.log(this.timevalue2);
          this.requestData.startTime = this.timevalue2[0] || "";
          this.requestData.endTime = this.timevalue2[1] || "";
        } else {
          this.requestData.startTime = "";
          this.requestData.endTime = "";
        }
      }
      this.$axios
        .post(api.getBillStatisticPage, this.requestData)
        .then(res => {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(errorHandler("获取临时停车费用分页失败"));
    },
    handleSizeChange(val) {
      this.requestData.pageSize = val;
      this.getPage();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getPage();
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    },
    timevalue2() {
      this.getPage();
    },
    "requestData.timeType": {
      handler() {
        // this.requestData.month = "";
        this.getPage();
      },
      deep: true
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>

<style scoped lang="less">
/deep/.el-radio-button__inner {
  line-height: 32px;
  height: 32px;
  padding: 0 20px;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #3276ff;
  border-color: #3276ff;
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/TemporaryParkingFee/TemporaryParkingFee.vue